 

export const FETCH_RIDES_SUCCESS = " FETCH_RIDES_SUCCESS";
export const FETCH_RIDES_FAILURE = "  FETCH_RIDES_FAILURE";
export const PROCESS_PAYMENT_SUCCESS = "  PROCESS_PAYMENT_SUCCESS";
export const PROCESS_PAYMENT_FAILURE = "  PROCESS_PAYMENT_FAILURE";
